import React, { memo, useCallback } from 'react';
import { FormattedMessage } from 'react-intl';
import { useLocation, useNavigate } from 'react-router-dom-v5-compat';

import { BannerLayout, BannerStatus } from 'ui-components/components/banner-message/banner-enums';
import { BannerMessageV2 } from 'ui-components/components/banner-message/banner-message-v2';
import { Text, TextType } from 'ui-components/components/text';
import { Button } from 'ui-components/components/button';

import { pages } from '../../../pages/settings/nav-items';
import { getCurrentDateTime } from '../../../services/datetime-service';
import { HAS_DISMISSED_EXPIRING_API_KEY_BANNER, useUserSpecificLocalStorage } from '../../../hooks/use-local-storage';

import { messages } from './messages';
import style from '../header-notification-banner.module.less';

const ApiSettingsPage = pages.api.location;
const SettingsBasePath = pages.settings.location;
const FullPathToApiSettingsPage = `/${SettingsBasePath}/${ApiSettingsPage}`;

const getPathToApiSettingsPage = (pathname) => {
  const isOnASettingsPage = pathname.includes(SettingsBasePath);

  const NavigateTo = isOnASettingsPage ? ApiSettingsPage : FullPathToApiSettingsPage;

  return NavigateTo;
};

export const ApiKeysExpiringBanner = memo(() => {
  const navigate = useNavigate();
  const { pathname } = useLocation();
  const apiSettingsPage = getPathToApiSettingsPage(pathname);

  const navigateToApiKeySettingsPage = useCallback(() => {
    if (!pathname.includes(FullPathToApiSettingsPage)) {
      navigate(apiSettingsPage);
    }
  }, [apiSettingsPage, navigate, pathname]);

  const [, setBannerDismissalDateTimeISO] = useUserSpecificLocalStorage(HAS_DISMISSED_EXPIRING_API_KEY_BANNER);

  const onClose = useCallback(() => {
    const now = getCurrentDateTime();
    setBannerDismissalDateTimeISO(now);
  }, [setBannerDismissalDateTimeISO]);

  return (
    <BannerMessageV2
      buttons={
        <Button onClick={navigateToApiKeySettingsPage} theme='link'>
          <FormattedMessage {...messages.learnMore} />
        </Button>
      }
      className={style['banner-padding']}
      content={<Text textType={TextType.Paragraph} value={messages.content} />}
      layout={BannerLayout.Default}
      onClose={onClose}
      status={BannerStatus.Warning}
    />
  );
});
